import { CKButton, CKTextFieldNext } from 'clearkit';
import React, { FC, useState } from 'react';

import { SettingsCard } from '~/components/unified/SettingsCard';

type FormMemberAddProps = {
  onChange: (value: string) => void;
};

export const FormMemberAdd: FC<FormMemberAddProps> = ({ onChange }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);

    await onChange(email);

    setIsLoading(false);
    setEmail('');
  };

  return (
    <SettingsCard>
      <SettingsCard.Header>
        <SettingsCard.Heading>Add a member to this team</SettingsCard.Heading>
      </SettingsCard.Header>
      <SettingsCard.Body className="flex items-end gap-4">
        <CKTextFieldNext
          className="grow"
          id="email"
          onChange={setEmail}
          placeholder="Enter email address"
          value={email}
        >
          <CKTextFieldNext.Label>Email address</CKTextFieldNext.Label>
        </CKTextFieldNext>
        <CKButton
          isLoading={isLoading}
          onClick={handleSubmit}
          type="submit"
          variant="bold"
          variantColor="blue"
        >
          Send invite
        </CKButton>
      </SettingsCard.Body>
    </SettingsCard>
  );
};
